module.exports = __webpack_public_path__ + "static/media/comming_soon.cbea65a1.png";